module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<article id="candidate-preferences"';
 if (review) { ;
__p += ' class="candidate-preferences-review"';
 } ;
__p += '>\n    <header>\n        <h1>Job Preferences</h1>\n        <p>\n            Help us improve your overall experience and ensure you\'re the first\n            to know when the perfect job comes along!\n        </p>\n    </header>\n\n    <form class="preferences-form">\n        <section class="prefs-group-general prefs-group">\n            <header>\n                <h2 class="section-title">Auto-apply</h2>\n            </header>\n\n            <h3>\n                Would you like us to automatically apply to similar jobs\n                when they become available?\n            </h3>\n            <ul class="checkbox-list checkbox-list-left">\n                <li>\n                    <input id="auto-apply" type="checkbox"\n                        name="auto_apply_enabled" value="1"';
 if (prefs.auto_apply_enabled) { ;
__p += ' checked';
 } ;
__p += ' />\n                    <label for="auto-apply">Enable Auto-apply</label>\n                </li>\n            </ul>\n\n            <header>\n                <h2 class="section-title">General</h2>\n            </header>\n\n            <section class="prefs-status">\n                <h3>Where are you in your job search?</h3>\n                <select name="search_status">\n                    <option value="1"';
 if (prefs.search_status == 1) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( statusMap[1] ) +
'</option>\n                    <option value="2"';
 if (prefs.search_status == 2) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( statusMap[2] ) +
'</option>\n                    <option value="3"';
 if (prefs.search_status == 3) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( statusMap[3] ) +
'</option>\n                    <option value="4"';
 if (prefs.search_status == 4) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( statusMap[4] ) +
'</option>\n\n                </select>\n            </section>\n\n            <section class="prefs-wage">\n                <h3>Minimum acceptable wage:</h3>\n                <div class="wage-pref-input">\n                    <span class="wage-input-prefix">$</span>\n                    <span class="wage-input-suffix">/hour</span>\n                    <input\n                        name="wage"\n                        type="number"\n                        step="1"\n                        min="10"\n                        max="40"\n                        value="' +
__e( prefs.wage ) +
'"\n                    />\n                </div>\n            </section>\n\n            <section class="prefs-roletype">\n                <h3>Types of jobs you\'re interested in:</h3>\n                <ul class="checkbox-list checkbox-list-left">\n                    <li>\n                        <input id="role-warehouse" type="checkbox" name="role" value="8"';
 if (prefs.role & 8) { ;
__p += ' checked';
 } ;
__p += ' />\n                        <label for="role-warehouse">Warehouse</label>\n                    </li>\n                    <li>\n                        <input id="role-trucking" type="checkbox" name="role" value="16"';
 if (prefs.role & 16) { ;
__p += ' checked';
 } ;
__p += ' />\n                        <label for="role-trucking">Trucking</label>\n                    </li>\n                    <li>\n                        <input id="role-production" type="checkbox" name="role" value="32"';
 if (prefs.role & 32) { ;
__p += ' checked';
 } ;
__p += ' />\n                        <label for="role-production">Manufacturing/Production</label>\n                    </li>\n                    <li>\n                        <input id="role-st" type="checkbox" name="role" value="64"';
 if (prefs.role & 64) { ;
__p += ' checked';
 } ;
__p += ' />\n                        <label for="role-st">Skilled Trades</label>\n                    </li>\n                </ul>\n            </section>\n        </section>\n\n        <section class="prefs-group-commute prefs-group">\n            <header>\n                <h2 class="section-title">Commute</h2>\n            </header>\n\n            <section class="prefs-commute-types">\n                <h3>How will you be getting to work?<br />Select the most likely option or options</h3>\n                <div class="prefs-commute-types-container">\n                    <input id="prefs-ct-driving" type="checkbox" name="commute_type" value="1"';
 if (prefs.commute_type & 1) { ;
__p += ' checked';
 } ;
__p += ' />\n                    <label for="prefs-ct-driving">\n                        ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n                        ' +
((__t = ( $.svgIcon('driving') )) == null ? '' : __t) +
'\n                        <span>Driving</span>\n                    </label>\n                    <input id="prefs-ct-transit" type="checkbox" name="commute_type" value="2"';
 if (prefs.commute_type & 2) { ;
__p += ' checked';
 } ;
__p += ' />\n                    <label for="prefs-ct-transit">\n                        ' +
((__t = ( $.svgIcon('approve') )) == null ? '' : __t) +
'\n                        ' +
((__t = ( $.svgIcon('transit') )) == null ? '' : __t) +
'\n                        <span>Transit</span>\n                    </label>\n                </div>\n            </section>\n\n            <section class="prefs-commute-length">\n                <h3>Max commute length</h3>\n                <div class="prefs-commute-length-container">\n                    <select name="commute_length">\n                        <option value="120">Doesn\'t matter</option>\n                        <option value="15"';
 if (prefs.commute_length === 15) { ;
__p += ' selected';
 } ;
__p += '>Within 15 minutes</option>\n                        <option value="30"';
 if (prefs.commute_length === 30) { ;
__p += ' selected';
 } ;
__p += '>Within 30 minutes</option>\n                        <option value="45"';
 if (prefs.commute_length === 45) { ;
__p += ' selected';
 } ;
__p += '>Within 45 minutes</option>\n                        <option value="60"';
 if (prefs.commute_length === 60) { ;
__p += ' selected';
 } ;
__p += '>Within 60 minutes</option>\n                    </select>\n                    <div class="form-error" style="display: none">Please select a max commute length</div>\n                    <section class="js-commute-address"></section>\n                    <section class="js-commute-address-input"></section>\n                </div>\n            </section>\n        </section>\n    </form>\n\n    <section class="prefs-group-shift prefs-group">\n        <header>\n            <h2 class="section-title">Shift</h2>\n        </header>\n\n        <section class="prefs-shifts">\n            <div class="availability-table"></div>\n        </section>\n    </section>\n\n    <footer>\n        <button class="btn btn-primary btn-large">\n            Save changes\n        </button>\n        <p>\n            <a href="#" class="js-save-and-view">Save &amp; see matching jobs</a>\n        </p>\n    </footer>\n</article>\n';

}
return __p
}